var _rect, _circle, _circle2, _circle3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignalTroRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140.6 307.76",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140.6,
    height: 307.76,
    ry: 44.816
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1085.1 -455.89)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -1014.4,
    cy: 611.11,
    r: 44.596,
    fill: "#666"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: -1014.4,
    cy: 705.6,
    r: 44.596,
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#fff"
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: -1014.8,
    cy: 516.62,
    r: 44.596,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.9515 0 0 2.0254 1330.1 -690.03)",
    fill: "#fff",
    style: {
      shapeInside: "url(#rect841)",
      whiteSpace: "pre"
    },
    "aria-label": "S"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-1193.1 582.1v3.8476q-2.2461-1.0742-4.2383-1.6016-1.9921-0.52734-3.8476-0.52734-3.2227 0-4.9805 1.25-1.7383 1.25-1.7383 3.5547 0 1.9336 1.1524 2.9297 1.1719 0.97656 4.414 1.582l2.3829 0.48828q4.414 0.83985 6.5039 2.9688 2.1093 2.1094 2.1093 5.6641 0 4.2383-2.8515 6.4258-2.8321 2.1875-8.3203 2.1875-2.0703 0-4.4141-0.46875-2.3242-0.46875-4.8242-1.3867v-4.0625q2.4023 1.3476 4.707 2.0312 2.3047 0.68359 4.5313 0.68359 3.3789 0 5.2148-1.3281 1.8359-1.3281 1.8359-3.7891 0-2.1484-1.3281-3.3594-1.3086-1.2109-4.3164-1.8164l-2.4023-0.46875q-4.4141-0.8789-6.3867-2.7539-1.9727-1.875-1.9727-5.2148 0-3.8672 2.7148-6.0938 2.7344-2.2266 7.5196-2.2266 2.0508 0 4.1797 0.37109 2.1289 0.3711 4.3554 1.1133z",
    fill: "#fff",
    stroke: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalTroRed);
export default __webpack_public_path__ + "static/media/signal_tro_red.28e1de6b58742ffab58f21367506b2a3.svg";
export { ForwardRef as ReactComponent };